export const getToken = state => state.auth.accesToken;
export const getLoggedIn = state => state.auth.isLoggedIn;
export const getLoading = state => state.auth.isLoading;
